const footer = () => {
    //Footer Dropdowns
    $(document).on('click', '.js__footer-dropdown', function(e) {
    	e.preventDefault();
    	const dropdownSection = $(this).data('dropdown-section');

    	$(this).toggleClass('showing');
    	$('.js__footer-dropdown-section[data-dropdown-section="'+dropdownSection+'"]').slideToggle();
    });
};